<template>
  <div class="ren-decoration-cp ren-decoration-cp-product-detail" :style="cardStyle">
    <strong>{{ title }}</strong>
    <span>{{ plainText }}</span>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { previewDataRecord, stringValue } from '../../../previews/preview-helpers'
import type { WidgetPreviewProps } from '../../types'

const props = defineProps<WidgetPreviewProps>()

const data = computed(() => previewDataRecord(props.componentData))
const title = computed(() => stringValue(props.component.props?.title, '商品详情'))
const plainText = computed(() =>
  stringValue(props.component.props?.html ?? data.value.detailHtml ?? data.value.html, '请输入内容')
    .replace(/<[^>]*>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
)
const cardStyle = computed(() => {
  const color = stringValue(props.component.style?.cardColor)
  return color ? { backgroundColor: color } : undefined
})
</script>

<style scoped>
.ren-decoration-cp-product-detail {
  display: grid;
  gap: 8px;
  padding: 12px;
}

.ren-decoration-cp-product-detail span {
  color: var(--ren-theme-muted);
  font-size: 12px;
  line-height: 1.7;
  overflow-wrap: anywhere;
}
</style>
